<template>
  <!-- 方法1:使用物件綁定，例：<ImagePicker :r="obj.storeImg" /> -->
  <!-- 方法2:使用空物件傳入，用 this.$emit("pick", url) 回傳值; -->
  <div>
    <div class="label">{{ r.label }}</div>
    <van-image :src="r.value" @click="show" width="100" />
    <!-- {{ r.value }} -->

    <!-- <el-drawer :visible="visible" direction="ttb" size="100%" show-close> -->
    <van-popup v-model="visible" position="top" closeable>
      <div class="main">
        <h1>選擇圖片</h1>
        <el-button type="text" @click="pick('')">清除設定</el-button>
        <van-row>
          <div v-for="r in images" :key="r" @click="pick(r)">
            <!-- <el-image :src="r" fit="fill" lazy-load height="3rem" />
            {{ r }} -->
            <van-col span="3" v-if="used(r)">
              <van-image class="used" :src="r" fit="fill" lazy-load />
            </van-col>
            <van-col span="3" v-else>
              <van-image :src="r" fit="fill" lazy-load />
            </van-col>
          </div>
        </van-row>
      </div>
    </van-popup>
    <!-- </el-drawer> -->
  </div>
</template>

<style scoped>
.label {
  margin-top: 1rem;
}

.used {
  background-color: rgba(1, 1, 1, 0.6);
  filter: grayscale(100%);
}
.van-image {
  margin: 0.5rem;
  /* width: 20rem; */
}
.el-drawer,
.van-popup {
  width: 100%;
  height: 100%;
}
.main {
  text-align: left;
  padding: 1rem;
}
</style>

<script>
export default {
  props: {
    r: Object,
  },
  data() {
    return {
      visible: false,
      images: null,
      bkmenu: null,
    };
  },
  mounted() {
    console.log("imagePicker.mounted");
    this.init();
  },
  methods: {
    async init() {
      try {
        var res = await this.apiGetBKMenu();
        this.bkmenu = res.data;
        res = await this.apiGetImages();
        this.images = res.data;
        // this.images = [];
        this.images = this.images.map((r) => {
          return this.$path.join("upload", r);
        });
      } catch (error) {
        console.log(error);
      }
    },
    used(src) {
      var extitem = this.bkmenu.extitem;
      var find = extitem.find((r) => r.imgfile == src);
      if (find) {
        return true;
      }
      return false;
    },

    async show() {
      console.log("imagePicker.show");
      this.$emit("pick", "");
      this.visible = true;
    },

    pick(url) {
      this.r.value = url;
      this.$emit("pick", url);
      this.visible = false;
    },
  },
};
</script>
